/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type CustomerUpdatePaginatedProperty =
  typeof CustomerUpdatePaginatedProperty[keyof typeof CustomerUpdatePaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerUpdatePaginatedProperty = {
  CREATED_AT: 'CREATED_AT',
  UPDATED_AT: 'UPDATED_AT',
} as const;
